/*! *********************************************************************
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */
import _clone from 'lodash/clone';
/**
 * Statuses of an Asset
 */
export var AssetStatus;
(function (AssetStatus) {
    AssetStatus["PENDING"] = "pending";
    AssetStatus["INVALID"] = "invalid";
    AssetStatus["DRAFT"] = "draft";
    AssetStatus["PUBLISHED"] = "published";
    AssetStatus["ARCHIVED"] = "archived";
})(AssetStatus || (AssetStatus = {}));
/**
 * Types for an Asset
 */
export var AssetType;
(function (AssetType) {
    AssetType["MATERIAL"] = "substanceMaterial";
    AssetType["SMART_MATERIAL"] = "painterSmartMaterial";
    AssetType["ATLAS"] = "substanceAtlas";
    AssetType["DECAL"] = "substanceDecal";
    AssetType["MODEL"] = "model";
    AssetType["FILTER"] = "substanceFilter";
    AssetType["TEXTURE_GENERATOR"] = "substance2DGenerator";
    AssetType["MESH_BASED_GENERATOR"] = "substanceMeshBasedGenerator";
    AssetType["IBL"] = "substanceIbl";
})(AssetType || (AssetType = {}));
/**
 * Kinds of a PreviewAttachment
 */
export var PreviewAttachmentKind;
(function (PreviewAttachmentKind) {
    PreviewAttachmentKind["IMAGE"] = "image";
    PreviewAttachmentKind["MODEL"] = "model";
})(PreviewAttachmentKind || (PreviewAttachmentKind = {}));
/**
 * Typenames for an Attachment
 */
export var AttachmentTypename;
(function (AttachmentTypename) {
    AttachmentTypename["DOWNLOAD"] = "DownloadAttachment";
    AttachmentTypename["PREVIEW"] = "PreviewAttachment";
})(AttachmentTypename || (AttachmentTypename = {}));
/**
 * Class used to describe an Asset from a graphql query
 */
var RawAsset = /** @class */ (function () {
    function RawAsset(rawAsset) {
        if (rawAsset)
            Object.assign(this, _clone(rawAsset));
    }
    return RawAsset;
}());
export default RawAsset;
